import "./App.css";

import AllRoutes from "./routes/AllRoutes";
import { BrowserRouter } from "react-router-dom";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { LoadScript } from "@react-google-maps/api";

// basename="/travel_guide/"

function App() {
  return (
    <>

      <BrowserRouter basename="">
        <ReactNotifications />
        <LoadScript

          googleMapsApiKey="AIzaSyC82fZSJymdGrJnap27r0enC7nQahR3E8Q"
          libraries={['places']}
        >

          <AllRoutes />
        </LoadScript>
      </BrowserRouter>

    </>
  );
}

export default App;
